enum API__PermissionLevelEnum {
    NUMBER_0 = 0,
    NUMBER_1 = 1,
    NUMBER_3 = 3,
}

export enum PermissionLevelEnum {
    None,
    Limited,
    Full,
}

export function isAvailable (permissionSection: iPermissionFields): boolean {
    return permissionSection.hasData && permissionSection.permissionLevel !== PermissionLevelEnum.None;
}

export interface iPermissionFields {
    permissionLevel: PermissionLevelEnum;
    hasData: boolean;
}

export class PermissionFields implements iPermissionFields {
    permissionLevel = PermissionLevelEnum.None;
    hasData = true;
}

export interface iPermissionSection<T> extends iPermissionFields {
    data?: T;
}

export class PermissionSection<T> implements iPermissionSection<T> {
    permissionLevel = PermissionLevelEnum.Full;
    hasData = true;
    data?: T = undefined;

    constructor(data?: iPermissionSection<T>) {
        if (data) {
            this.setData(data);
        }
    }

    private setData (data: iPermissionSection<T>) {
        ({
            data: this.data,
            hasData: this.hasData,
            permissionLevel: this.permissionLevel,
        } = data);
    }

    static getPermissionLevel(level: API__PermissionLevelEnum = 0): PermissionLevelEnum {
        switch (level) {
            case API__PermissionLevelEnum.NUMBER_0: return PermissionLevelEnum.None;
            case API__PermissionLevelEnum.NUMBER_1: return PermissionLevelEnum.Limited;
            case API__PermissionLevelEnum.NUMBER_3: return PermissionLevelEnum.Full;
            default: return PermissionLevelEnum.None;
        }
    }
}